var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container"},[_c('b-form-checkbox',{attrs:{"id":`staff${_vm.data.checkbox.id}`,"value":true,"unchecked-value":false},nativeOn:{"change":function($event){return _vm.onCheckboxClick(_vm.data.checkbox.emit)}},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }